module.exports = __webpack_public_path__ + "src/assets/fonts/hero-pro-full-v2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/hero-pro-full-v2.woff
// module id = 973
// module chunks = 1